import { render, staticRenderFns } from "./RencanaAksiPusat.vue?vue&type=template&id=5f259520&"
import script from "./RencanaAksiPusat.vue?vue&type=script&lang=js&"
export * from "./RencanaAksiPusat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports